import React  from 'react';


import AboutContent from "../content/AboutContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

// import { Helmet } from "react-helmet-async";

function About() {
    return(
        <>
        <Navbar />
        <AboutContent/>
        <Footer />        
        </>
    );
}

export default About;